import PeluangPenawaran from './PeluangPenawaran';

export default PeluangPenawaran;
